import { AVAILABILITY_AS_TYPES, CALENDAR_TYPES } from '@/views/constants'

const DEFAULT_AVAILABILITY_AS = AVAILABILITY_AS_TYPES.SELF
const DEFAULT_AVAILABILITY_SETTINGS = {
  type: DEFAULT_AVAILABILITY_AS
}

/*
  set of communication settings for calendar
  includes next settings "availability_as", "review_as", "notification_as"
  widget use only "availability_as" settings
  there are 3 types of "availability_as" settings
    1. "self" - AVAILABILITY_AS_TYPES.SELF - show calendar with all original data
    2. "practice" - AVAILABILITY_AS_TYPES.PRACTICE - show calendar as practice
    3. "calendar" - AVAILABILITY_AS_TYPES.CALENDAR - show calendar availability as other provider
  all of this settings could be set only for provider/provider_location calendar types
 */
export default class CalendarCommunicationSettings {
  constructor (communicationSettings = {}, calendarType = CALENDAR_TYPES.PRACTICE_TYPE) {
    const settings = communicationSettings && !Array.isArray(communicationSettings) ? communicationSettings : {}
    const calendarTypeAllowsSettings = [CALENDAR_TYPES.PROVIDER_LOCATION_TYPE, CALENDAR_TYPES.PROVIDER_TYPE].includes(calendarType)
    this.availabilitySettings = {
      type: DEFAULT_AVAILABILITY_AS
    }
    if (calendarTypeAllowsSettings && settings?.availability_as) {
      this.availabilitySettings = settings?.availability_as
    }
    this.availabilityType = this.availabilitySettings.type
    this.availabilityCalendarId = (this.showAsOtherCalendar && +this.availabilitySettings.id) || null
    // set to self if other calendar id not set
    if (this.showAsOtherCalendar && !this.availabilityCalendarId) {
      this.availabilitySettings = DEFAULT_AVAILABILITY_SETTINGS
      this.availabilityType = this.availabilitySettings.type
    }
  }

  get showAsSelf () {
    return this.availabilityType === AVAILABILITY_AS_TYPES.SELF
  }

  get showAsPractice () {
    return this.availabilityType === AVAILABILITY_AS_TYPES.PRACTICE
  }

  get showAsOtherCalendar () {
    return this.availabilityType === AVAILABILITY_AS_TYPES.CALENDAR
  }
}
